/*
 * leasing-anfrage-wizard.js
 * -------------------------------------------------------------------
 * Vanilla-JS fuer die Dienstrad-Leasing-Anfrage.
 * Ablauf: zuerst NUR Rollen-Wahl (Arbeitnehmer | Arbeitgeber, ohne Default).
 * Nach der Wahl erscheint dynamisch der jeweilige Multi-Step-Wizard.
 * Kein Ersparnis-/Impact-Rechner, kein Gehalts-/Job-Setup mehr.
 *
 * Endpoint: <data-proxy>/inquiry (POST JSON)
 * Spam: Honeypot `_website` + Min-Time `_t`.
 */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.dataset.laInit === '1') return;
    root.dataset.laInit = '1';

    var PROXY = (root.getAttribute('data-proxy') || '/apps/apps/mts/api/leasing-inquiry').replace(/\/$/, '');
    var CONSENT_VERSION = root.getAttribute('data-consent-version') || 'leasing-inquiry-consent-v1';
    var loadedAt = Date.now();

    var chooser = root.querySelector('[data-role-chooser]');
    var panels = root.querySelectorAll('[data-role-panel]');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Scrollt das uebergebene Element an den oberen Rand (block:start respektiert
    // scroll-margin-top aus dem CSS -> Sticky-Header-Offset). Nur scrollen, wenn
    // das Ziel nicht ohnehin schon weitgehend im Viewport sichtbar ist (verhindert
    // unnoetiges Springen). Fallback: window.scrollTo.
    function scrollToEl(el) {
      if (!el) return;
      try {
        var r = el.getBoundingClientRect();
        var needScroll = r.top < 70 || r.top > (window.innerHeight * 0.5);
        if (!needScroll) return;
        if (el.scrollIntoView) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      } catch (e) {}
      var top = el.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // -- Rollen-Wahl ---------------------------------------------------------
    function showChooser() {
      if (chooser) chooser.hidden = false;
      panels.forEach(function (p) { p.hidden = true; });
    }
    function chooseRole(role) {
      if (chooser) chooser.hidden = true;
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-role-panel') !== role; });
      var active = root.querySelector('[data-role-panel="' + role + '"]');
      if (active) {
        // ggf. Success zuruecksetzen, falls erneut gewaehlt
        var success = active.querySelector('[data-la-success]');
        var stepsWrap = active.querySelector('[data-la-steps]');
        var prog = active.querySelector('[data-la-progress]');
        if (success) success.hidden = true;
        if (stepsWrap) stepsWrap.hidden = false;
        if (prog) prog.hidden = false;
        goToStep(active, 0, false);
        scrollToEl(active);
      }
    }

    root.addEventListener('click', function (ev) {
      var rc = ev.target.closest('[data-choose-role]');
      if (rc) { ev.preventDefault(); chooseRole(rc.getAttribute('data-choose-role')); return; }
      var back = ev.target.closest('[data-la-roles-back]');
      if (back) { ev.preventDefault(); showChooser(); scrollToEl(chooser); return; }
    });

    // -- Step-Navigation -----------------------------------------------------
    function steps(panel) { return Array.prototype.slice.call(panel.querySelectorAll('[data-step]')); }
    function currentIndex(panel) {
      var all = steps(panel);
      for (var i = 0; i < all.length; i++) { if (!all[i].hidden) return i; }
      return 0;
    }
    function updateProgress(panel, index) {
      var all = steps(panel);
      var bar = panel.querySelector('[data-la-progress-bar]');
      var label = panel.querySelector('[data-la-progress-label]');
      var pct = all.length > 1 ? Math.round(index / (all.length - 1) * 100) : 0;
      if (bar) bar.style.width = pct + '%';
      if (label) label.textContent = 'Schritt ' + (index + 1) + ' von ' + all.length;
      panel.querySelectorAll('[data-la-dot]').forEach(function (d, di) {
        d.setAttribute('data-active', di <= index ? 'true' : 'false');
        d.setAttribute('aria-current', di === index ? 'step' : 'false');
      });
    }
    function goToStep(panel, index, focus) {
      var all = steps(panel);
      index = Math.max(0, Math.min(index, all.length - 1));
      all.forEach(function (s, si) { s.hidden = si !== index; });
      updateProgress(panel, index);
      if (focus !== false) {
        var f = all[index].querySelector('input, select, textarea, button');
        if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
        scrollToEl(panel);
      }
    }

    // -- Validierung ---------------------------------------------------------
    function fieldError(field, msg) {
      var wrap = field.closest('[data-field]') || field.parentElement;
      if (!wrap) return;
      wrap.setAttribute('data-invalid', 'true');
      var err = wrap.querySelector('[data-field-error]');
      if (err) err.textContent = msg || 'Bitte pruefen';
      field.setAttribute('aria-invalid', 'true');
    }
    function clearError(field) {
      var wrap = field.closest('[data-field]') || field.parentElement;
      if (!wrap) return;
      wrap.removeAttribute('data-invalid');
      var err = wrap.querySelector('[data-field-error]');
      if (err) err.textContent = '';
      field.removeAttribute('aria-invalid');
    }
    function validateStep(stepEl) {
      var ok = true;
      stepEl.querySelectorAll('[data-required]').forEach(function (f) {
        clearError(f);
        if (f.type === 'radio') {
          var any = false;
          stepEl.querySelectorAll('input[name="' + f.name + '"]').forEach(function (g) { if (g.checked) any = true; });
          if (!any) { ok = false; fieldError(f, 'Bitte auswaehlen'); }
          return;
        }
        if (f.type === 'checkbox') {
          if (!f.checked) { ok = false; fieldError(f, 'Bitte bestaetigen'); }
          return;
        }
        var val = (f.value || '').trim();
        if (!val) { ok = false; fieldError(f, 'Pflichtfeld'); return; }
        if (f.getAttribute('data-validate') === 'email' && !EMAIL_RE.test(val)) {
          ok = false; fieldError(f, 'Bitte gueltige E-Mail eingeben');
        }
      });
      return ok;
    }
    root.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t && t.hasAttribute && t.hasAttribute('data-required')) clearError(t);
      if (t && t.name === 'bikeBudget') {
        var lab = t.closest('[data-role-panel]').querySelector('[data-la-budget-display]');
        if (lab) lab.textContent = (parseFloat(t.value) || 0).toLocaleString('de-DE') + ' €';
      }
    });
    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t) return;
      if (t.name === 'secondBike') {
        var b2 = root.querySelector('[data-second-bike-wrap]');
        if (b2) b2.hidden = !t.checked;
      }
      if (t.name === 'employerContactConsent') {
        var ec = root.querySelector('[data-employer-email-wrap]');
        if (ec) ec.hidden = !t.checked;
      }
    });

    // -- Sammeln + Senden ----------------------------------------------------
    function getVal(panel, name) {
      var el = panel.querySelector('[name="' + name + '"]');
      if (!el) return '';
      if (el.type === 'checkbox') return el.checked;
      if (el.type === 'radio') {
        var sel = panel.querySelector('input[name="' + name + '"]:checked');
        return sel ? sel.value : '';
      }
      return (el.value || '').trim();
    }
    function getNum(panel, name) { var v = parseFloat(getVal(panel, name)); return isNaN(v) ? null : v; }
    function getChecks(panel, name) {
      var out = [];
      panel.querySelectorAll('input[name="' + name + '"]:checked').forEach(function (c) { out.push(c.value); });
      return out;
    }

    function buildPayload(role, panel) {
      var base = {
        applicantType: role,
        _website: getVal(panel, '_website'),
        _t: loadedAt,
        privacyConsent: getVal(panel, 'privacyConsent') === true,
        consentVersion: CONSENT_VERSION,
        newsletterOptIn: getVal(panel, 'newsletterOptIn') === true,
        nachricht: getVal(panel, 'nachricht'),
        customer: {
          vorname: getVal(panel, 'vorname'),
          nachname: getVal(panel, 'nachname'),
          email: getVal(panel, 'email'),
          telefon: getVal(panel, 'telefon'),
          contactPref: getVal(panel, 'contactPref'),
          bestTime: getVal(panel, 'bestTime')
        }
      };
      if (role === 'arbeitnehmer') {
        var ek = getVal(panel, 'employerKnown');
        base.intent = (ek === 'nein' || ek === 'weiss_nicht') ? 'employee_needs_employer_buyin' : 'employee_ready';
        base.employeeDetails = {
          bikeCategory: getVal(panel, 'bikeCategory'),
          bikeBudget: getNum(panel, 'bikeBudget'),
          bikeModelWish: getVal(panel, 'bikeModelWish'),
          secondBike: getVal(panel, 'secondBike') === true,
          bikeBudget2: getNum(panel, 'bikeBudget2'),
          employerKnown: ek,
          employerName: getVal(panel, 'employerName'),
          employerSize: getVal(panel, 'employerSize'),
          employerContactConsent: getVal(panel, 'employerContactConsent') === true,
          employerContactEmail: getVal(panel, 'employerContactEmail')
        };
      } else {
        base.employerDetails = {
          firmenname: getVal(panel, 'firmenname'),
          rechtsform: getVal(panel, 'rechtsform'),
          unternehmensgroesse: getVal(panel, 'unternehmensgroesse'),
          branche: getVal(panel, 'branche'),
          bundesland: getVal(panel, 'bundesland'),
          interessierteMitarbeiter: getNum(panel, 'interessierteMitarbeiter'),
          konkretheit: getVal(panel, 'konkretheit'),
          mehrereRaeder: getVal(panel, 'mehrereRaeder'),
          eBikes: getVal(panel, 'eBikes'),
          bestehendeBenefits: getChecks(panel, 'bestehendeBenefits'),
          bestehendesProgramm: getVal(panel, 'bestehendesProgramm'),
          payrollSystem: getVal(panel, 'payrollSystem'),
          payrollAbwicklung: getVal(panel, 'payrollAbwicklung'),
          ansprechpartner: {
            vorname: getVal(panel, 'vorname'),
            nachname: getVal(panel, 'nachname'),
            position: getVal(panel, 'position')
          },
          gewuenschterStart: getVal(panel, 'gewuenschterStart'),
          bevorzugteAnbieter: getChecks(panel, 'bevorzugteAnbieter'),
          consultationOnly: getVal(panel, 'consultationOnly') === true
        };
      }
      return base;
    }

    function showSuccess(panel, refId) {
      var success = panel.querySelector('[data-la-success]');
      var stepsWrap = panel.querySelector('[data-la-steps]');
      var prog = panel.querySelector('[data-la-progress]');
      if (stepsWrap) stepsWrap.hidden = true;
      if (prog) prog.hidden = true;
      if (success) {
        success.hidden = false;
        var refEl = success.querySelector('[data-la-ref]');
        if (refEl && refId) refEl.textContent = refId;
        scrollToEl(success);
      }
    }
    function setBusy(btn, busy) {
      if (!btn) return;
      btn.disabled = busy;
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      var label = btn.querySelector('[data-btn-label]');
      if (label) {
        if (busy) { btn.dataset.prev = label.textContent; label.textContent = 'Senden…'; }
        else if (btn.dataset.prev) { label.textContent = btn.dataset.prev; }
      }
    }

    async function submit(role, panel, btn) {
      var globalErr = panel.querySelector('[data-la-form-error]');
      if (globalErr) globalErr.textContent = '';
      setBusy(btn, true);
      try {
        var payload = buildPayload(role, panel);
        var resp = await fetch(PROXY + '/inquiry', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = {};
        try { data = await resp.json(); } catch (e) {}
        if (resp.ok && data && data.success && data.referenceId) { showSuccess(panel, data.referenceId); return; }
        if (resp.ok && data && data.success && !data.referenceId) {
          if (globalErr) globalErr.textContent = 'Deine Anfrage konnte nicht zugeordnet werden. Bitte lade die Seite neu und sende sie erneut.';
          return;
        }
        if (resp.status === 400 && data && data.errors) {
          if (globalErr) globalErr.textContent = 'Bitte pruefe deine Angaben (' + data.errors.join(', ') + ').';
        } else if (resp.status === 429) {
          if (globalErr) globalErr.textContent = 'Zu viele Anfragen. Bitte versuche es in einer Minute erneut.';
        } else {
          if (globalErr) globalErr.textContent = 'Senden fehlgeschlagen. Bitte spaeter erneut versuchen oder per E-Mail an info@movetoshop.de.';
        }
      } catch (err) {
        if (globalErr) globalErr.textContent = 'Netzwerkfehler. Bitte spaeter erneut versuchen.';
      } finally {
        setBusy(btn, false);
      }
    }

    // -- Button-Delegation (Next/Prev/Submit) --------------------------------
    root.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-la-next], [data-la-prev], [data-la-submit]');
      if (!btn) return;
      var panel = btn.closest('[data-role-panel]');
      if (!panel) return;
      var role = panel.getAttribute('data-role-panel');
      var idx = currentIndex(panel);
      var all = steps(panel);
      if (btn.hasAttribute('data-la-prev')) {
        ev.preventDefault();
        if (idx === 0) { showChooser(); scrollToEl(chooser); } else { goToStep(panel, idx - 1); }
      } else if (btn.hasAttribute('data-la-next')) {
        ev.preventDefault();
        if (!validateStep(all[idx])) return;
        goToStep(panel, idx + 1);
      } else if (btn.hasAttribute('data-la-submit')) {
        ev.preventDefault();
        if (!validateStep(all[idx])) return;
        submit(role, panel, btn);
      }
    });

    // -- Init: nur Chooser sichtbar, keine Rolle vorgewaehlt -----------------
    showChooser();
    panels.forEach(function (p) { goToStep(p, 0, false); });
  }

  function boot() { document.querySelectorAll('[data-leasing-anfrage]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
